import {Component, ElementRef, ViewChild, inject} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, NgForm, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {throwError, forkJoin} from 'rxjs';
import {BaseGridNoCookieComponent} from 'app/core-ui/abstract/basegrid/basegridnocookie.component';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {VisualsService} from 'app/core-ui/abstract/services/visuals.service';
import {DynamicFormComponent} from 'app/core-ui/dynamic-form/containers/dynamic-form/dynamic-form.component';
import {ModalDirective} from 'ngx-bootstrap/modal';
import {FileSaverService} from 'ngx-filesaver';
import {ResendInvitationService} from './resendInvitation.service';
import {ApproveClientUploadRowComponent} from '../ApproveClientUploadRow/approveClientUploadRow.component';

@Component({
  selector: 'resendInvitation-grid',
  templateUrl: './resendInvitation.component.html',
  providers: [ResendInvitationService],
})
export class ResendInvitationComponent extends BaseGridNoCookieComponent<ResendInvitationService> {
  @ViewChild('confirmModal')
  public confirmModal: ModalDirective;

  @ViewChild('rejectModal')
  public rejectModal: ModalDirective;

  @ViewChild('uploadModal')
  public uploadModal: ModalDirective;

  @ViewChild(DynamicFormComponent)
  public form: DynamicFormComponent;

  @ViewChild('inputFile') 
  public myInputVariable: ElementRef;

  @ViewChild(ApproveClientUploadRowComponent)
  ApproveClientUploadRowComponent;

  public hideDropFileArea: boolean = false;
  public submiting: boolean = false;
  tagName: string;
  isCollapsed: boolean = true;
  _FileSaverService: FileSaverService = inject(FileSaverService);
  canUploadExcel: boolean;
  canPerformGridActions: boolean;
  isSubmitted: boolean = false;
  rejectionForm: UntypedFormGroup;
  rejectionReasonValue: string;

  constructor(
    public gridService: ResendInvitationService,
    public eventsEmitterService: EventsEmitterService,
    public securityService: SecurityService,
    logger: LogService,
    public fb: UntypedFormBuilder,
    visualsService: VisualsService,
    public route: ActivatedRoute,
    public router: Router,
    elem: ElementRef
  ) {
    super(securityService, logger, visualsService, gridService, 'resendInvitation');
    this.tagName = elem.nativeElement.tagName.toLowerCase();
    this.sort = '';
    this.buildForm();
    this.canPerformActions();
    this.loadVisuals();
    this.eventsEmitterService.languageChange.subscribe({
      next: (langId) => {
        this.loadVisuals();
        this.getValidationMessages();
      },
    });
    this.checkboxPK = 'cliId';
  }

  buildForm() {
    this.rejectionForm = this.fb.group({
      rejectionReason: ['', [Validators.required,Validators.maxLength(250)]],
    });
  }

  private canPerformActions(): void {
    forkJoin([this.securityService.canPerformAction("ResendInvitationComponent", "uploadExcel"),
            this.securityService.canPerformAction("ResendInvitationComponent", "gridActions")])
            .subscribe({
      next: (response) => {
        this.canUploadExcel = response[0].data;
        this.canPerformGridActions = response[1].data;
        this.viewRole = !response[1].data;
      },
      error: (error) => {
        return throwError(() => new Error(error));
      },
    });
  }

  getCheckboxCallback() {
    this.checkboxPKArray = [];
    this.checkboxPKArrayFull = [];
    this.gridService.getPKs(this.dataCountParams()).subscribe({
      next: (data) => {
        this.checkboxPKArrayFull = data.data;
      },
      error: (error) => {
        return throwError(() => new Error(error));
      },
    });
  }
  afterFormInit(formConfig: any) {
    let debtorId = this.route.snapshot.queryParamMap.get('buyerId');
    let hasUrlParamKey = this.route.snapshot.queryParams.hasOwnProperty('param');
    if (this.form && this.form.controls.length > 0 && hasUrlParamKey) {
      this.form.setValue('dbtrId', debtorId);
      this.submit(this.form.value);
    }
  }
  handleModalOutput(event: any) {
    if (event.modalname == 'debtorModal') {
      this.form.setValue('dbtrId', event.value.dbtrId);
    }
  }
  downloadExcel() {
    this.submiting = true;
    this.gridService.downloadExcel().subscribe({
      next: (data) => {
        // var blob = new Blob([data.data.valLabelByte], {type: "application/octet-stream"});
        var blob = new Blob([this.s2ab(atob(data.data.valLabelByte))], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        var fileName = data.data.val + '.xlsx';
        this._FileSaverService.save(blob, fileName);
      },
      error: (error) => {
        return throwError(() => new Error(error));
      },
    });
  }
  downloadBankExcel() {
    this.submiting = true;
    this.gridService.downloadBankExcel().subscribe({
      next: (data) => {
        // var blob = new Blob([data.data.valLabelByte], {type: "application/octet-stream"});
        var blob = new Blob([this.s2ab(atob(data.data.valLabelByte))], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        var fileName = data.data.val + '.xlsx';
        this._FileSaverService.save(blob, fileName);
      },
      error: (error) => {
        return throwError(() => new Error(error));
      },
    });
  }
  s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }
  public sendEmail() {
    if (this.checkboxPKArray.length == 0) {
      return;
    }
    this.submiting = true;
    this.gridService.resendEmail(this.checkboxPKArray).subscribe({
      next: (data) => {
        LogService.emitAlert({
          type: 'success',
          body: data.message,
        });
      },
      error: (error) => {
        return throwError(() => new Error(error));
      },
    });
  }

  refreshTable() {
    this.uploadModal.hide();
    this.sort = '';
    this.submit(this.form.value);
  }

  public uploadCsv() {
    this.hideDropFileArea = !this.hideDropFileArea;
  }

  upload() {
    this.uploadModal.show();
  }

  public refreshView() {
    this.hideDropFileArea = false;
    this.search();
  }

  public reject(params) {
    if (this.checkboxPKArray.length === 0) {
      LogService.emitAlert({
        type: 'info',
        body: 'Please select at least one invitation to reject.',
      });
      return;
    }
    this.openRejectionPopup(params);
  }

  private openRejectionPopup(params) {
    this.isSubmitted = false;
    this.rejectModal.show();
  }

  onSubmit(rejectionReasonValue?: NgForm): void {
    this.isSubmitted = true;
  
    if (!this.rejectionForm.valid) {
      console.log('Form is invalid');
      return;
    }
  
    const rejectionReason: string = this.rejectionForm.value.rejectionReason;
  
    this.gridService.rejectInvitations(this.checkboxPKArray, rejectionReason).subscribe({
      next: (data) => this.handleSuccess(data.message),
      error: (error) => this.handleError(error),
    });
  }
  
  private handleSuccess(message: string): void {
    LogService.emitAlert({ type: 'success', body: message });
    this.resetFormState();
  }
  
  private handleError(error: any): void {
    console.error('Error:', error);
    LogService.emitAlert({ type: 'error', body: 'An error occurred during rejection.' });
    this.resetFormState();
  }
  
  private resetFormState(): void {
    this.isSubmitted = false;
    this.rejectionForm.reset();
    this.rejectModal.hide();
    this.search();
  }
}
